import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'

export default {
  props: {
    calledId: String,
    called: Object,
    isToShow: Boolean,
  },

  created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))

    if (this.called) {
      this.currentCalled = this.called
      this.currentServiceOrder = this.called.serviceOrder

      if (this.isToShow) {
        this.currentServiceOrderRating = this.called.rating
      }
    } else {
      this.getCalled()
    }
  },

  data: () => ({
    step: 0,
    institution: {},
    errorMessage: '',
    loading: false,
    pdfLoading: false,
    firstValid: false,
    error: false,
    userLogged: {},
    currentCalled: {},
    currentServiceOrder: {},
    currentServiceOrderRating: {
      id: 0,
      serviceOrderId: 0,
      calledId: 0,
      rating: 0,
      observation: '',
    },
    ratingRules: [(v) => !!v || 'Avaliação requerida'],
    apiService: new ApiService(),
  }),

  computed: {
    buttonText() {
      switch (this.step) {
        case 0:
          return 'Confirmar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    getCalled() {
      this.apiService
        .get(`called/${this.institution.id}/${this.calledId}`)
        .then((response) => {
          this.currentCalled = response.content
          this.currentServiceOrder = response.content.serviceOrder
        })
    },

    close() {
      this.$emit('close')
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          this.submit()
        }
      } else {
        this.close()
      }
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },

    async generatePDF() {
      this.pdfLoading = true
      const serviceOrderPrintModel = {
        ServiceOrder: this.currentServiceOrder,
        User: this.userLogged,
      }
      await this.apiService
        .post('serviceOrder/printServiceOrder', serviceOrderPrintModel)
        .then((response) => {
          var w = window.open('')
          w.document.write(response.content.html)
        })
      this.pdfLoading = false
    },

    async submit() {
      this.loading = true

      const serviceOrderRating = {
        Id: this.currentServiceOrderRating.id,
        ServiceOrderId: this.currentServiceOrder.id,
        CalledId: this.currentCalled.id,
        Rating: this.currentServiceOrderRating.rating,
        Observation: this.currentServiceOrderRating.observation,
      }

      await this.apiService
        .post('serviceOrder/addRating', serviceOrderRating)
        .then(() => {
          this.step++
          this.userLogged.pendingCalleds = []
          localStorage.removeItem('user')
          localStorage.setItem('user', JSON.stringify(this.userLogged))
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
    },
  },

  watch: {},
}
